import React from 'react';
import * as _ from 'lodash';
import { Redirect } from 'react-router-dom';
import Moment from 'moment';
import { TermsOfServiceMiddle } from '@bld/bld-libs/components';
import { SEARCH_PARAMS_SESSION_PAGE } from '@bld/bld-libs/constants';

import { WORK_HOUR_ZONES, TARGET_DEVICE } from '../utilities/constants';
import { isPartnerCompany, roleIdToRoleName } from '../utilities/roleUtility';
import { UserProfileService } from '../services/UserProfiles';
import { DirectLinkService } from '../services/DirectLinks';
import LocalStorageService from '../services/utilities/LocalStorageService';
import SessionStorageService from '../services/utilities/SessionStorageService';
import Information from './modals/common/Information';
import Confirmation from './modals/common/Confirmation';
import { messageUtility } from '../utilities/messageUtility';
import AuthProvider from '../utilities/authProvider';
import {
  isTargetRoleId,
  isForemanRoleId,
  isPartnerRoleId,
} from '../utilities/roleUtility';
import {
  USER_ROLES,
  DOES_NOT_UPDATE_OWN_PASSWORD,
} from '../utilities/constants';
import {
  setCompanyNameForGTM,
  setCompanyBranchNameForGTM,
  setUserCreatedAtForGTM,
} from '../utilities/gtm';
import userAgentService from '../services/userAgent';
import { datadog } from '../utilities/datadog';

const REDIRCT_STATE = {
  NONE: 'NONE',
  FIELDS: 'FIELDS',
  SUCCEED: 'SUCCEED',
  BLOCK_USER: 'BLOCK_USER', // アカウント停止ユーザー
  PATCH_ERROR: 'PATCH_ERROR',
  DIRECT_LINK_NOT_FOUND: 'DIRECT_LINK_NOT_FOUND',
};

const DIRECT_LINK_STATE = {
  NONE: 'NONE',
  RECORD_NOT_FOUND: 'RECORD_NOT_FOUND',
  EXPIRED: 'EXPIRED',
  DEVICE_ERROR: 'DEVICE_ERROR',
  LOGIN_ID_ERROR: 'LOGIN_ID_ERROR',
};

/**
 * ログインのコールバッククラス
 *
 * @export
 * @class LoginCallback
 * @extends {React.Component}
 */
export class LoginCallback extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      user: null,
      isManual: false, // 遷移しなくて手動で遷移したかどうか
      redirectState: REDIRCT_STATE.NONE,
      directLinkState: DIRECT_LINK_STATE.NONE,
      directLink: null,
    };

    this.isUnmounted = false; // 非同期メソッド内でアンマウント後にsetStateしないための制御フラグです
    this.authProvider = this.props.authProvider;
    this.userProfileId = null;
    this.afterSwitchUser = SessionStorageService.getAfterSwitchUser();
  }

  async componentDidMount() {
    // 開発者コンソールの初期化
    // eruda.init();
    //const loggedInUser = await this.authProvider.saveAuthUserInfo();
    let loggedInUser = null;
    loggedInUser = await this.authProvider.saveAuthUserInfo();

    if (loggedInUser != null) {
      const relayPoint = SessionStorageService.getRelayPoint();
      let directLink = null;
      if (relayPoint) {
        directLink = await this.fetchDirectLink(relayPoint);
        if (directLink) {
          SessionStorageService.setItem(
            'directLink',
            JSON.stringify(directLink)
          );
          if (relayPoint.switchUserFlag === undefined) {
            relayPoint.switchUserFlag =
              directLink.user_id &&
              directLink.user_id !==
                Number(LocalStorageService.getItem('user_id'));
          }
          if (relayPoint.switchCompanyFlag === undefined) {
            relayPoint.switchCompanyFlag =
              directLink.company_id &&
              directLink.company_id !==
                Number(SessionStorageService.getItem('company_id'));
          }
          SessionStorageService.setItem(
            'relayPoint',
            JSON.stringify(relayPoint)
          );
        } else {
          SessionStorageService.removeItem('relayPoint');
        }
      }
      this.setState({ user: loggedInUser, directLink }, () => {
        this.fetchUserProfile(false);
      });
    }
  }

  componentWillUnmount() {
    this.isUnmounted = true;
    // eruda.hide();
    // eruda.destroy();
  }

  saveInitDataToStorage() {
    if (
      !SessionStorageService.getDirectLink() ||
      !SessionStorageService.getItem('date_from')
    ) {
      SessionStorageService.setItem('date_from', Moment().format('YYYY/MM/DD'));
      SessionStorageService.setItem('date_to', Moment().format('YYYY/MM/DD'));
      SessionStorageService.setItem('work_hour_zone', WORK_HOUR_ZONES.day.id);
    }
    SessionStorageService.setItem('is_conference', 0);
    SessionStorageService.setItem('slideClosed', 1);
    SessionStorageService.removeItem(SEARCH_PARAMS_SESSION_PAGE.FIELDS);
  }

  /**
   * ユーザー情報を取得します
   *
   * @memberof LoginCallback
   */
  fetchUserProfile(isManual = false) {
    // API
    UserProfileService.index()
      .then(response => {
        if (this.isUnmounted) {
          return;
        }
        // responseがnullなど
        if (_.isEmpty(response)) {
          return;
        }
        if (!response.result) {
          if (response.status === 403) {
            this.setState({ redirectState: REDIRCT_STATE.BLOCK_USER });
          } else {
            this.setState({ redirectState: REDIRCT_STATE.NONE });
          }
          return;
        }

        const entity = response.data.entities;
        const directLink = this.state.directLink;
        const skipTerm = SessionStorageService.getSkipTerm();
        const skipPasswordInit = SessionStorageService.getSkipPasswordInit();

        this.userProfileId = entity.user_profile.id;
        LocalStorageService.setItem('user_id', entity.user_profile.id); // ユーザーID
        LocalStorageService.setItem('role_id', entity.role_code); // ロール
        LocalStorageService.setItem('login_id', entity.session.login_id); // ログインID

        // DataDogのユーザーセッションを更新する
        datadog.updateUser();

        if (
          !directLink ||
          !isPartnerRoleId(LocalStorageService.getRoleId()) ||
          !SessionStorageService.getCompanyId()
        ) {
          SessionStorageService.setItem('company_id', entity.company[0].id);
          SessionStorageService.setItem(
            'company_branch_id',
            entity.company_branch[0] ? entity.company_branch[0].id : null
          );
          SessionStorageService.setItem(
            'prime_company_id',
            isPartnerCompany(roleIdToRoleName(entity.role_code))
              ? entity.company[0].id
              : null
          );
        }

        SessionStorageService.setItem(
          'buildee_company_code',
          entity.company[0].buildee_company_code
        );

        setUserCreatedAtForGTM(entity.user_profile.created_at);
        setCompanyNameForGTM(entity.company[0].name);
        setCompanyBranchNameForGTM(
          entity.company_branch[0] ? entity.company_branch[0].name : ''
        );

        if (
          isTargetRoleId(
            [USER_ROLES.branch, USER_ROLES.manager],
            entity.role_code
          ) &&
          _.size(entity.company_branch) > 0
        ) {
          SessionStorageService.setItem(
            'contract_flag',
            entity.company_branch[0].contract_flag
          );
        }

        // 職長ユーザーの場合は元請け選択等がないので、ログイン時に会社情報をセットしておく
        if (isTargetRoleId([USER_ROLES.foreman], entity.role_code)) {
          SessionStorageService.setSessionSelectedPartnerCompanyId(
            entity.company[0].id
          );
        }
        SessionStorageService.removeItem('invitation_status');

        // 直リンクから遷移
        if (directLink) {
          if (directLink.record_not_found) {
            this.setState({ directLinkState: DIRECT_LINK_STATE.RECORD_NOT_FOUND });
            return;
          } else if (
            directLink.expiration &&
            Moment().isAfter(Moment(directLink.expiration))
          ) {
            this.setState({ directLinkState: DIRECT_LINK_STATE.EXPIRED });
            return;
          } else if (
            (directLink.target_device === TARGET_DEVICE.pc &&
              userAgentService.isMobileAccess()) ||
            (directLink.target_device === TARGET_DEVICE.mobile &&
              !userAgentService.isMobileAccess())
          ) {
            this.setState({ directLinkState: DIRECT_LINK_STATE.DEVICE_ERROR });
            return;
          } else if (
            directLink.login_id &&
            directLink.login_id !== entity.session.login_id
          ) {
            const relayPoint = SessionStorageService.getRelayPoint();
            if (
              relayPoint.expectedLoginId &&
              relayPoint.expectedLoginId != entity.session.login_id
            ) {
              SessionStorageService.removeItem('relayPoint');
              SessionStorageService.removeItem('directLink');
            } else {
              this.setState({
                directLinkState: DIRECT_LINK_STATE.LOGIN_ID_ERROR,
              });
              return;
            }
          }
        }

        // スマホチェック
        const userAgent = window.navigator.userAgent.toLowerCase();
        if (userAgent.includes('iphone')) {
          if (!directLink) {
            SessionStorageService.removeCurrentField();
            SessionStorageService.removeCurrentPartnerCompanyData();
          }
          window.location.href = '/sp/dashboard';
          return;
        } else if (
          userAgent.includes('android') &&
          userAgent.includes('mobile')
        ) {
          if (!directLink) {
            SessionStorageService.removeCurrentField();
            SessionStorageService.removeCurrentPartnerCompanyData();
          }
          window.location.href = '/sp/dashboard';
          return;
        }

        // まだユーザ情報を入れていないユーザー
        const doesNotUpdateOwnPassword =
          entity.session.updated_own_password_flag === false;
        if (doesNotUpdateOwnPassword && !skipPasswordInit) {
          // isEmptyをONにする
          SessionStorageService.setItem(
            'isEmpty',
            DOES_NOT_UPDATE_OWN_PASSWORD
          );
        }

        if (!entity.user_profile.agreed_terms_flag && !skipTerm) {
          document.querySelector('._loading_overlay_wrapper').style.display =
            'none';
          this.setState({
            redirectState: REDIRCT_STATE.FIELDS,
            isManual,
          });
        } else {
          this.setState({
            redirectState: REDIRCT_STATE.SUCCEED,
            isManual,
          });
        }
        // 職長の場合、元請選択画面が表示されないためこちらで共通化フラグを設定
        if (isForemanRoleId(entity.role_code)) {
          SessionStorageService.setPartnerCompanyJoiningFlag(
            entity.company[0].joining_flag
          );
        }
      })
      .catch(e => {
        console.log(e);
      });
  }

  async fetchDirectLink(relayPoint) {
    if (!relayPoint) {
      return;
    }
    if (relayPoint && !relayPoint.linkKey) {
      SessionStorageService.removeItem('relayPoint');
      return window.location.replace('/error-permission');
    }
    let directLink = null;
    await DirectLinkService.index({ link_key: relayPoint.linkKey })
      .then(response => {
        if (response.result) {
          directLink = _.get(response, 'data.entities.direct_link');
          if (!directLink) {
            directLink = { record_not_found: true }
          }
        }
      })
      .catch(e => {
        console.log(e);
        SessionStorageService.removeItem('relayPoint');
        if (e.status === 404) {
          return window.location.replace('/error-permission');
        }
      });
    return directLink;
  }

  handleManualLocation() {
    //AuthProvider.instance.silentTokenUdate();
    this.authProvider.silentTokenUdate().then(
      () => this.fetchUserProfile(true),
      e => {
        console.error(e);
      }
    );
    /*
    setTimeout(() => {
      this.fetchUserProfile(true);
    }, 3000);
    */
  }

  render() {
    switch (this.state.directLinkState) {
      case DIRECT_LINK_STATE.RECORD_NOT_FOUND: {
        return (
          <Information
            visible={this.state.directLinkState === DIRECT_LINK_STATE.RECORD_NOT_FOUND}
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            message={
              <React.Fragment>
                <div>
                  {messageUtility.getMessage('E-000-074')}
                  <br />
                  <br />
                  {messageUtility.getMessage('I-000-139')}
                </div>
              </React.Fragment>
            }
            buttonText={messageUtility.getMessage('I-000-138')}
            onClose={() => {
              SessionStorageService.removeItem('relayPoint');
              SessionStorageService.removeItem('directLink');
              if (userAgentService.isMobileAccess()) {
                window.location.href = '/sp/dashboard';
              } else {
                window.location.href = '/';
              }
            }}
          />
        );
      }
      case DIRECT_LINK_STATE.EXPIRED: {
        return (
          <Information
            visible={this.state.directLinkState === DIRECT_LINK_STATE.EXPIRED}
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            message={
              <React.Fragment>
                <div>
                  {messageUtility.getMessage('E-000-057')}
                  <br />
                  <br />
                  {messageUtility.getMessage('I-000-139')}
                </div>
              </React.Fragment>
            }
            buttonText={messageUtility.getMessage('I-000-138')}
            onClose={() => {
              SessionStorageService.removeItem('relayPoint');
              SessionStorageService.removeItem('directLink');
              if (userAgentService.isMobileAccess()) {
                window.location.href = '/sp/dashboard';
              } else {
                window.location.href = '/';
              }
            }}
          />
        );
      }
      case DIRECT_LINK_STATE.DEVICE_ERROR: {
        const expectedDevice = userAgentService.isMobileAccess()
          ? 'PCまたはタブレット端末'
          : 'モバイル端末';
        return (
          <Information
            visible={
              this.state.directLinkState === DIRECT_LINK_STATE.DEVICE_ERROR
            }
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            message={
              <React.Fragment>
                <div>
                  {expectedDevice}でないとご利用できない画面へのリンクです。
                  <br />
                  {expectedDevice}で操作してください。
                  <br />
                  <br />
                  {messageUtility.getMessage('I-000-139')}
                </div>
              </React.Fragment>
            }
            buttonText={messageUtility.getMessage('I-000-138')}
            onClose={() => {
              SessionStorageService.removeItem('relayPoint');
              SessionStorageService.removeItem('directLink');
              if (userAgentService.isMobileAccess()) {
                window.location.href = '/sp/dashboard';
              } else {
                window.location.href = '/';
              }
            }}
          />
        );
      }
      case DIRECT_LINK_STATE.LOGIN_ID_ERROR: {
        return (
          <Confirmation
            visible={
              this.state.directLinkState === DIRECT_LINK_STATE.LOGIN_ID_ERROR
            }
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            message={
              <React.Fragment>
                <div>
                  現在他のユーザーIDでログイン中です。
                  <br />
                  ログイン中のユーザーと異なるユーザーのページへアクセスしようとしています。
                  <br />
                  このページにアクセスするには現在操作中のIDからログアウトし、下記のIDで再度ログインしてください。
                  <br />
                  <br />
                  {this.state.directLink.login_id}
                  <br />
                  <br />
                  {messageUtility.getMessage('I-000-139')}
                  <br />
                </div>
              </React.Fragment>
            }
            confirmButtonText={'ログアウト'}
            onConfirm={() => {
              SessionStorageService.removeInformationRelatedToField();
              SessionStorageService.setAfterLoginEventsFlag(false);
              const relayPoint = SessionStorageService.getRelayPoint();
              AuthProvider.instance.logout({
                post_logout_redirect_uri: `${
                  window.location.origin
                }/relay_point?__sender=${relayPoint.sender}&__parameter=${
                  relayPoint.linkKey
                }&loginId=${encodeURI(
                  relayPoint.loginId
                )}&expectedLoginId=${encodeURI(relayPoint.loginId)}`,
              });
            }}
            cancelButtonText={messageUtility.getMessage('I-000-138')}
            onCancel={() => {
              SessionStorageService.removeItem('relayPoint');
              SessionStorageService.removeItem('directLink');
              if (userAgentService.isMobileAccess()) {
                window.location.href = '/sp/dashboard';
              } else {
                window.location.href = '/';
              }
            }}
          />
        );
      }
    }

    if (!this.state.user && !this.state.isManual) {
      return (
        <React.Fragment>
          <div>ログイン処理中...</div>
          <div>
            <div
              style={{
                margin: '20px 0 10px 20px',
                fontSize: '0.9em',
                color: '#aaa',
                lineHeight: '22px',
              }}
            >
              ご利用環境によってはログイン後に画面が切り替わらないことがあります。
              <br />
              30秒以上経っても画面が切り替わらない場合は、下の「移動しない場合はこちら」ボタンを押してください。
              <br />
              <span>
                PCの時刻にずれがある可能性があります。時刻設定の確認をお願いします。
              </span>
            </div>
            <button
              className='btn--sub'
              style={{ margin: '20px 0 0 20px' }}
              onClick={this.handleManualLocation.bind(this)}
            >
              移動しない場合はこちら
            </button>
          </div>
        </React.Fragment>
      );
    }

    this.saveInitDataToStorage();
    switch (this.state.redirectState) {
      case REDIRCT_STATE.NONE: {
        // return null;
        return <div>ログイン成功しました!</div>;
      }
      case REDIRCT_STATE.FIELDS: {
        return (
          <TermsOfServiceMiddle
            accept={() => {
              UserProfileService.update(this.userProfileId)
                .then(response => {
                  if (response.result) {
                    document.querySelector(
                      '._loading_overlay_wrapper'
                    ).style.display = '';
                    this.setState({ redirectState: REDIRCT_STATE.SUCCEED });
                  } else {
                    this.setState({
                      redirectState: REDIRCT_STATE.PATCH_ERROR,
                    });
                  }
                })
                .catch(error => {
                  this.setState({ redirectState: REDIRCT_STATE.PATCH_ERROR });
                });
            }}
            deny={() => {
              AuthProvider.instance.logout();
            }}
          />
        );
      }
      case REDIRCT_STATE.SUCCEED: {
        const directLink = this.state.directLink;
        if (!directLink) {
          // ログイン時にSessionStorageにFieldIdとそれに関連する情報を持っている場合は消す(自分の所属していない現場の可能性がある)。
          SessionStorageService.removeInformationRelatedToField();
        }
        if (this.afterSwitchUser) {
          SessionStorageService.setAfterLoginEventsFlag(false);
        } else {
          SessionStorageService.setAfterLoginEventsFlag(true);
        }
        if (
          sessionStorage.getItem('isEmpty') === DOES_NOT_UPDATE_OWN_PASSWORD
        ) {
          return <Redirect to='/user-edit' />;
        } else {
          return <Redirect to='/conference/Fields/0/0/0:1/0:0' />;
        }
      }
      case REDIRCT_STATE.BLOCK_USER: {
        return (
          <Information
            visible={this.state.redirectState === REDIRCT_STATE.BLOCK_USER}
            message={messageUtility.getMessage('E-001-008')}
            buttonText={messageUtility.getMessage('I-000-011')}
            onClose={() => AuthProvider.instance.logout()}
            buttonClassName='btn--sm--sub'
          />
        );
      }
      case REDIRCT_STATE.PATCH_ERROR: {
        return (
          <Information
            visible={this.state.redirectState === REDIRCT_STATE.PATCH_ERROR}
            title={messageUtility.getMessage('E-001-402')}
            multilineText={true}
            message={
              <React.Fragment>
                <div>
                  しばらく時間をおいてから再度お試しください。
                  <br />
                  <br />
                  このエラーが何度も発生する場合にはお客様がご利用のネットワーク設定やセキュリティソフトの設定が影響している可能性がございます。
                  <br />
                  <br />
                  お使いのブラウザが Internet explorer の場合には
                  https://buildee.jp と https://*.buildee.jp
                  を信頼済みサイトに追加してください。
                  <br />
                  社内に情報セキュリティ部門が存在するお客様は社内ネットワークにてPATCH、PUT、DELETEによるWebへのアクセスを許可されているかご確認ください。
                  <br />
                  Buildeeをご利用いただくためにはPATCH、PUT、DELETEが実行可能な動作環境が必要です。
                </div>
              </React.Fragment>
            }
            buttonText={messageUtility.getMessage('I-000-017')}
            onClose={() => AuthProvider.instance.logout()}
          />
        );
      }
      default: {
        return null;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginCallback.js